export default __webpack_public_path__ + "25e184a638be1a4d9798e53d0889908d.woff2";